






































import {Vue, Component, Prop, Watch, Ref} from 'vue-property-decorator'
import {Getter} from "vuex-class";

@Component({})
export default class SmsTextInputWings extends Vue {
  @Prop(String) value!: string;
  @Prop({default:true}) readonly show_counter: boolean | undefined;
  @Prop({default:'textarea'}) readonly type!: string;
  @Prop() readonly errors: any;

  @Getter('personalisationList') personalisationList: any;

  private valueSelf = this.value;
  private personalisation: string | null = null;
  private resetting = false;
  private templateField: any = undefined

  get count(): number {
    if (!this.valueSelf) return 0;
    return this.valueSelf.length
  }

  get countSMS(): number {
    let countSms = 1;

    if (this.isTextUnicode) {
      if (this.count > 70) {
        countSms = Math.ceil(this.count / 67);
      }
    } else {
      if (this.count > 160) {
        countSms = Math.ceil(this.count / 153);
      }
    }
    return countSms;
  };

  get isTextUnicode(): boolean {
    let text = this.valueSelf;
    for (let charPos = 0; charPos < text.length; charPos++) {
      if (text.charCodeAt(charPos) > 127) {
        return true;
      }
    }
    return false;
  };

  transliterate(text:string, engToRus:boolean):string {
    let charList:any = {
      Ё:"YO",Й:"J",Ц:"CZ",У:"U",К:"K",Е:"E",Н:"N",Г:"G",Ш:"SH",Щ:"SHH",З:"Z",
      Х:"X",Ъ:"``",ё:"yo",й:"j",ц:"cz",у:"u",к:"k",е:"e",н:"n",г:"g",ш:"sh",щ:"ssh",
      з:"z",х:"x",ъ:"``",Ф:"F",Ы:"Y'",В:"V",А:"A",П:"P",Р:"R",О:"O",Л:"L",Д:"D",Ж:"ZH",
      Э:"E`",ф:"f",ы:"y",в:"v",а:"a",п:"p",р:"r",о:"o",л:"l",д:"d",ж:"ZH",э:"e`",Я:"YA",
      Ч:"CH",С:"S",М:"M",И:"I",Т:"T",Ь:"'",Б:"B",Ю:"YU",я:"ya",ч:"ch",с:"s",м:"m",и:"i",
      т:"t",ь:"'",б:"b",ю:"yu"
    };
    return text.split(/(?=\$)/g).map(function (char) {
      return char.split(/(?=[.,-/:-?{-~!"^_;`\[\] ])/g).map((item) => {
        if (item.substring(0, 1) !== "$") {
          return item.split("").map((elem) => {
            return engToRus ? Object.keys(charList).find(key => charList[key] === elem) || elem : charList[elem] || elem;
          }).join("");
        } else {
          return item;
        }
      }).join("");
    }).join("");
  }

  mounted() {
    this.templateField = this.$refs.container
    this.templateField = this.templateField.querySelector('textarea, input[type="text"]')
  }

  addPersonalisation($event: string) {
    if (!$event) return;
    this.$emit('change', $event)
    const startPos = this.templateField.selectionStart
    const endPos = this.templateField.selectionEnd
    if (this.templateField.selectionStart || this.templateField.selectionStart === 0) {
      this.valueSelf = this.valueSelf.substring(0, startPos) + $event + this.valueSelf.substring(endPos, this.valueSelf.length)
    } else {
      this.valueSelf += $event;
    }
    this.resetPersonalisationSelect();
  }

  resetPersonalisationSelect():void {
    this.personalisation = null;
    this.resetting = true;
    setTimeout(() => {
      this.resetting = false
    }, 1)
  }

  @Watch('value')
  getValue(val: string) {
    this.valueSelf = val
  }

  @Watch('valueSelf')
  sendValue(val: string) {
    this.$emit('input', val)
  }

}
